import type { ReactNode } from 'react';

export const symbol_mobile_cancel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm220-338 91 91q9 9 21 9t21-9q9-9 9-21t-9-21l-91-91 91-91q9-9 9-21t-9-21q-9-9-21-9t-21 9l-91 91-91-91q-9-9-21-9t-21 9q-9 9-9 21t9 21l91 91-91 91q-9 9-9 21t9 21q9 9 21 9t21-9l91-91Z"
		/>
	</svg>
);
